<template>
  <label for="check-all-plans">
    <img :src="AllPlansIcon" />
    <span>{{ text }}</span>
    <input
      id="check-all-plans"
      type="checkbox"
      :checked="checked"
      @input="model = !model"
    >
  </label>
</template>

<script lang="ts" setup>
import AllPlansIcon from '@/assets/icons/all-plans.svg';
import { computed } from 'vue';

const props = defineProps<{
  text: string;
  checked: boolean;
}>();
const emits = defineEmits(['update:checked']);

const model = computed({
  get: () => props.checked,
  set: (newValue) => {
    console.log(newValue);
    emits('update:checked', newValue);
  },
});
</script>

<script lang="ts">
export default {
  name: 'TheCheckboxPlanAll',
};
</script>

<style scoped lang="scss">
label {
  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
  background: #f9f9f9;
  border-radius: 3px;
  padding: 10px 16px;

  input[type='checkbox'] {
    position: relative;
    border: 2px solid #161e57;
    background: none;
    cursor: pointer;
    line-height: 0;
    margin: 0 0.6em 0 0;
    outline: 0;
    padding: 0 !important;
    vertical-align: text-top;
    height: 20px;
    width: 20px;
    -webkit-appearance: none;
    //opacity: .5;
    border-radius: 3px;
    min-width: 20px;
    max-width: 20px;
    min-height: 20px;
    max-height: 20px;
  }

  input[type='checkbox']:hover {
    opacity: 1;
  }

  input[type='checkbox']:checked {
    background-color: #161e57;
    opacity: 1;
  }

  input[type='checkbox']:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 16px;
    height: 16px;
    background: url('../../../assets/icons/check-white-solid.svg') no-repeat
      center;
    z-index: 2;
  }

  img {
    margin-right: 16px;
  }

  span {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    font-family: 'Circe Rg', sans-serif;
    color: #161e57;
    margin-right: 16px;
    width: -webkit-fill-available;
    display: block;
  }
}
</style>
